import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
} from 'react-admin';
import { List, ListItem, ListItemText } from '@mui/material';
import { TaskListItem } from './TaskListItem';

export const TaskListContent = ({
    openEditDrawer,
}: {
    openEditDrawer: (id: string | number) => void;
}) => {
    const { data: tasks, error, isPending } = useListContext();

    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) {
        return null;
    }
    return (
        <List dense>
            {tasks.map(task => (
                <RecordContextProvider key={task.id} value={task}>
                    <TaskListItem
                        task={task}
                        showMember
                        openEditDrawer={openEditDrawer}
                    />
                </RecordContextProvider>
            ))}
            {tasks.length === 0 && (
                <ListItem>
                    <ListItemText primary="All tasks are done, well done!" />
                </ListItem>
            )}
        </List>
    );
};
